<span *ngIf="loaded">
  <div *ngIf="categoryTree && categoryTree.length > 0">
    <p class="filter-header">{{ translateService.instant('CATEGORY') }}</p>
    <ul class="category-tree">
      <li *ngFor="let category of categoryTree" class="category-node">
        <div class="category-item" (click)="nodeClicked(category, $event)" [ngClass]="{ selected: category.selected }" [style.padding]="!hasAnySubcategories ? '0.5rem 1rem' : '0.5rem 0.7rem'">
          <!-- Toggle arrow icon (chevron/caret) -->
          <span class="toggle-icon" *ngIf="category.subcategories.length > 0"
                (click)="toggleExpand(category); $event.stopPropagation()">
            <i [class]="category.expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
          </span>
          <span class="toggle-placeholder" *ngIf="category.subcategories.length === 0 && hasAnySubcategories"></span>

          <!-- Category name -->
          <span class="category-name">
            {{ translateService.instant(category.name) }}
          </span>
        </div>

        <!-- Nested subcategories (shown when expanded) -->
        <ul *ngIf="category.expanded && category.subcategories.length > 0" class="subcategory-list">
          <li *ngFor="let subcategory of category.subcategories"
              class="subcategory-item"
              (click)="nodeClicked(subcategory, $event)"
              [ngClass]="{ selected: subcategory.selected }">
            <span class="subcategory-name">
              {{ translateService.instant(subcategory.name) }}
            </span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
  <div *ngIf="categoryTree && categoryTree.length > 0" class="divider"></div>

  <div *ngFor="let specialSelectionFilter of specialSelectionFilters"
    class="form-check special-filter checkbox-selection" (click)="specialSelectionClicked(specialSelectionFilter)">
    <span class="form-check-label" for="{{ specialSelectionFilter.name }}" translate>
      {{ translateService.instant(specialSelectionFilter.name) }}
    </span>
    <span class="checkbox">
      <i *ngIf="specialSelectionFilter.valueList[0].selected" class="fas fa-check-square"></i>
      <i *ngIf="!specialSelectionFilter.valueList[0].selected" class="fas fa-square"></i>
    </span>
  </div>
  <div *ngIf="specialSelectionFilters?.length > 0" class="divider"></div>

  @if (assortmentOptions?.length > 0) {
  <div class="p-3 pb-2">
    <lib-gung-select-option-input gungTranslate="STORE_TEMPLATES" [optionsList]="assortmentOptions"
      [(ngModel)]="selectedAssortmentId" [showId]="false"
      (ngModelChange)="selectAssortment($event, false)"></lib-gung-select-option-input>
  </div>
  <div class="divider"></div>
  }

  <p class="filter-header" translate>FILTERS</p>
  <lib-filter-list-side-filter [ngClass]="{ 'd-none': i >= showMoreLimit && !showMore }" [renderFilter]="renderFilter"
    *ngFor="let renderFilter of regularFilters; let i = index"
    (selectValue)="setSelection(renderFilter.name, $event, true)"
    (deselectValue)="setSelection(renderFilter.name, $event, false)"
    (selectValueRange)="setSelection(renderFilter.name, null, true, $event)"></lib-filter-list-side-filter>
  <div class="filter-expand" *ngIf="renderFilters.length > showMoreLimit">
    <button type="button" class="button btn btn-link" (click)="showMore = !showMore">
      {{ showMore ? translateService.instant('HIDE') : translateService.instant('SEE_MORE') }}
    </button>
  </div>
</span>
